var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("title", null, "Icn/Feedback");

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0.149932215 0.0288 8.86615977 0.0288 8.86615977 9.9128475 0.149932215 9.9128475"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-3",
  points: "0.199602509 0.173864155 6.43585465 0.173864155 6.43585465 7.65 0.199602509 7.65"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-5",
  points: "0 0.1688625 14.5114336 0.1688625 14.5114336 13.9573459 0 13.9573459"
}));

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  id: "Icn/Feedback",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-16"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(17.924370, 0.196200)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.163815126,4.4556975 L1.97984874,0.1993725 C2.08989076,0.0175725 2.2360084,-0.0191025 2.42001681,0.0900225 L3.57579832,0.7994475 C3.72191597,0.9452475 3.7407479,1.1090475 3.63070588,1.2906225 L0.714252101,4.7832975 C0.567,4.8921975 0.420201681,4.9108725 0.273857143,4.8377475 C0.163815126,4.7286225 0.126831933,4.6014975 0.163815126,4.4556975 M2.97022689,6.6386475 C3.11657143,6.8208975 3.2817479,6.8566725 3.46552941,6.7477725 L8.58327731,4.1283225 C8.80336134,3.9834225 8.83966387,3.7829475 8.69331933,3.5280225 L7.75784874,2.1091725 C7.57384034,1.9275975 7.37258824,1.9098225 7.1525042,2.0544975 L3.02536134,6.1474725 C2.87833613,6.2932725 2.86041176,6.4568475 2.97022689,6.6386475 M3.90592437,9.3123225 L8.19801681,7.5663225 C8.41832773,7.4936475 8.54652101,7.5663225 8.58327731,7.7845725 L8.8584958,9.0942975 C8.89457143,9.3123225 8.80336134,9.4403475 8.58327731,9.4761225 L4.01596639,9.9128475 C3.86894118,9.9128475 3.75867227,9.8223975 3.68561345,9.6399225 C3.68561345,9.4947975 3.75867227,9.3858975 3.90592437,9.3123225",
  id: "Fill-1",
  fill: "#F4BD00",
  mask: "url(#mask-2)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(5.672269, 19.321200)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.70246807,6.9405975 L4.82190504,7.4317725 C4.4547958,7.6500225 4.07906471,7.7046975 3.6938042,7.5955725 C3.30877059,7.4862225 3.00609832,7.2492975 2.78601429,6.8859225 L0.419770588,2.9569725 C0.199686555,2.5569225 0.144552101,2.1656475 0.254594118,1.7835975 C0.364636134,1.4015475 0.602871429,1.1016225 0.969980672,0.8833725 L1.85031681,0.3921975 C2.21674538,0.1739475 2.59338403,0.1192725 2.97864454,0.2283975 C3.36367815,0.3375225 3.66635042,0.5746725 3.88643445,0.9378225 L6.25267815,4.8667725 C6.43577899,5.2668225 6.48161092,5.6583225 6.39017395,6.0403725 C6.29828319,6.4221975 6.06866975,6.7223475 5.70246807,6.9405975",
  id: "Fill-4",
  fill: "#B8D1DA",
  mask: "url(#mask-4)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-9",
  transform: "translate(0.000000, 8.521200)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-6",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.38597983,13.9206375 C3.39560168,13.8481875 2.29472773,12.9749625 1.08426555,11.3011875 C0.0936605042,9.5191875 -0.218314286,8.1635625 0.148794958,7.2358875 C0.514996639,6.3082125 0.772063866,5.8442625 0.919315966,5.8442625 L8.67829916,0.1688625 L14.5114336,9.2278125 L5.98170252,13.8115125 C5.90796303,13.9573459 5.37658487,13.9939875 4.38597983,13.9206375",
  id: "Fill-7",
  fill: "#7BB3CD",
  mask: "url(#mask-6)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M19.2988513,8.3081475 C20.6195824,10.3817475 21.5827336,12.2917725 22.1878513,14.0379975 C22.7931958,15.7844475 22.8567252,16.8576975 22.3804815,17.2577475 C21.756305,17.5493475 20.7847588,17.0581725 19.4640277,15.7844475 C18.1432966,14.5111725 16.813263,12.8373975 15.4743807,10.7637975 C14.1345908,8.6901975 13.1630445,6.7893975 12.5577,5.0611725 C11.9523555,3.3338475 11.9060697,2.2506975 12.4202042,1.8141975 C13.0067168,1.5601725 13.9696412,2.0691225 15.3092042,3.3423975 C16.6480866,4.6161225 17.9781202,6.2709975 19.2988513,8.3081475",
  id: "Fill-10",
  fill: "#617483"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.4906597,17.1485325 C22.3066513,17.5850325 21.9213908,17.8399575 21.3348782,17.9126325 C19.9404076,17.9859825 18.3265336,18.1131075 16.4923487,18.2944575 L13.4107185,18.5673825 C13.3739622,18.6765075 12.8691303,18.5948325 11.897584,18.3219075 C10.9251303,18.0489825 9.79702941,17.0034075 8.51305462,15.1840575 C7.37565126,13.2195825 6.88034874,11.7555075 7.02737395,10.7911575 C7.1734916,9.8274825 7.30259244,9.3450825 7.41263445,9.3450825 L9.00858403,6.7256325 C9.96197899,5.1252075 10.7694832,3.7063575 11.4297353,2.4690825 C11.7228782,1.9968075 12.0899874,1.7785575 12.5303824,1.8143325 C12.4931723,1.8143325 12.4382647,1.8330075 12.3652059,1.8687825 C11.9250378,2.2328325 12.0350798,3.2698575 12.6953319,4.9794075 C13.3558109,6.6898575 14.346416,8.5724325 15.6669202,10.6273575 C16.9876513,12.6831825 18.2895504,14.3655075 19.573979,15.6752325 C20.8577269,16.9849575 21.7750462,17.5305825 22.3254832,17.3123325 C22.398542,17.2765575 22.4534496,17.2218825 22.4906597,17.1485325",
  id: "Fill-12",
  fill: "#D1D1D1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.68021513,16.71192 C2.53318992,16.821045 2.38593782,16.87572 2.24004706,16.87572 C1.98275294,16.87572 1.78082017,16.766595 1.63447563,16.548345 C1.48767731,16.32987 1.43254286,16.12107 1.46952605,15.920595 C1.50560168,15.721245 1.6156437,15.565995 1.7996521,15.45687 L4.99132437,13.43772 C5.2114084,13.29282 5.42218992,13.24692 5.62412269,13.30137 C5.82560168,13.35582 5.98192941,13.474395 6.09197143,13.65597 C6.20201345,13.838445 6.23808908,14.02947 6.20201345,14.22882 C6.16503025,14.429295 6.05498824,14.583645 5.87188739,14.69277 L2.68021513,16.71192",
  id: "Fill-14",
  fill: "#B8D1DA"
})));

var SvgFeedback = function SvgFeedback(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFeedback, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Feedback.947304fd.svg";
export { ForwardRef as ReactComponent };